import React, { useState } from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Button, Collapse } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import HelpIcon from "@material-ui/icons/Help";

import HoverTooltip from "@Components/Tooltip/HoverTooltip";
import CommentTranslationContainer from "@Views/Grievance/Comment/CommentTranslationContainer";
import AudioPlayer from "@Components/AudioPlayer";
import { TRANSLATION_DISCLAIMER_MESSAGE } from "../../../configs/constants";
import { InfoRounded } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  nameSpan: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

const CommentBodyContainer = (props) => {
  const { comment, comments, setComments, userLanguage, renderOnly } = props;
  const [openTranslationContainer, setOpenTranslationContainer] = useState(
    false
  );
  const [showTranslatedText, setShowTranslatedText] = useState(true);
  const classes = useStyles();
  const { t } = useTranslation();


  let tempDate;
  try {
    tempDate = new Date(comment.created_at);
    tempDate = tempDate.toLocaleString("en-AU", { hour12: true }).toUpperCase();
  } catch (e) {
    tempDate = comment.datetime;
  }

  return (
    <div
      style={{
        backgroundColor: comment.is_internal ? "#f6efdd" : "#FFFFFF",
        margin: "5px",
        padding: "5px",
      }}
    >
      {/*{comment.translated_from ? (*/}
      {/*  <Typography variant="subtitle2" style={{ textTransform: "none" }}>*/}
      {/*    Translation Available*/}
      {/*  </Typography>*/}
      {/*) : null}*/}
      <Typography variant="subtitle2" style={{ textTransform: "capitalize" }}>
        <HoverTooltip title={`${comment.author_roles}`}>
          <span className={classes.nameSpan}>{comment.author}</span>
        </HoverTooltip>{" "}
        | {tempDate}
        {comment.is_original_grievance ? " | Original Grievance" : null}
        {comment.is_internal ? " | Internal" : null}
        {comment.is_additional_information ? " | Additional Information" : null}
        {comment.is_additional_information
          ? comment.is_audio_message
            ? " | Audio"
            : " | Text"
          : null}
      </Typography>

      {comment.is_audio_message ? (
        <AudioPlayer audioSrc={comment.audio_file} />
      ) : (
        <Typography variant="body1">{comment.text_message}</Typography>
      )}

      {!comment.is_internal ? (
        <span
          className={classes.nameSpan}
          style={{
            display: "flex",
            fontWeight: "normal",
          }}
          onClick={() => setOpenTranslationContainer(!openTranslationContainer)}
        >
          {t("Show Translation")}{" "}
          {openTranslationContainer ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </span>
      ) : null}

      {comment.is_translated && showTranslatedText ? (
        <Collapse in={openTranslationContainer} unmountOnExit>
          <Grid style={{ padding: "10px" }} container spacing={1}>
            <Grid item container spacing={1} direction="row">
              <Grid item>
                <span>{comment.translated_text}</span>
              </Grid>
              <Grid item>
                <HoverTooltip title={TRANSLATION_DISCLAIMER_MESSAGE}>
                  <IconButton>
                    <InfoRounded
                      style={{ position: "absolute" }}
                      color="primary"
                    />
                  </IconButton>
                </HoverTooltip>
              </Grid>
            </Grid>
            <Grid
              style={{ marginTop: "10px" }}
              item
              container
              spacing={2}
              alignItems="center"
            >
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    borderRadius: 0,
                    top: "2px",
                    textTransform: "capitalize",
                  }}
                  disabled={comment.allowed_translation_count <= 0}
                  size="small"
                  onClick={() => setShowTranslatedText(false)}
                >
                  {t("Translate Again")}
                </Button>
              </Grid>
              <Grid item>
                <HoverTooltip
                  title={ `${t("You have")} ${comment.allowed_translation_count} ${t("translation left.")}`}
                  placement="right"
                >
                  <IconButton>
                    <HelpIcon style={{ position: "absolute" }} />
                  </IconButton>
                </HoverTooltip>
              </Grid>
            </Grid>
          </Grid>
        </Collapse>
      ) : (
        <Collapse in={openTranslationContainer} unmountOnExit>
          <CommentTranslationContainer
            comment={comment}
            comments={comments}
            setComments={setComments}
            setShowTranslatedText={setShowTranslatedText}
            userLanguage={userLanguage}
            renderOnly={renderOnly}
          />
        </Collapse>
      )}
    </div>
  );
};
CommentBodyContainer.propTypes = {
  comment: PropTypes.object,
  comments: PropTypes.array,
  setComments: PropTypes.func,
  userLanguage: PropTypes.string,
  renderOnly: PropTypes.bool,
};

export default CommentBodyContainer;
